
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Avatar, Box, Chip, Typography } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import { getMeetingUsers, getUserFullName, sortByProperty } from "app/utils/appHelpers";
import config from "config";
import { useTemplateFontSettings } from "styles/templateFontSettings";

function PreviewMeetingUsersCard({ meeting, meetingUsers }) {

    const [members, setMembers] = useState([]);
    const [participants, setParticipants] = useState([]);
    const userList = useSelector((state) => state.user.data);

    useEffect(() => {
        const fetchParticipants = async () => {
            try {
                const meetingUsersParticipants = await getMeetingUsers(meeting.id, userList, meetingUsers);

                if (meetingUsersParticipants && meetingUsersParticipants.length > 0) {
                    let memberList = meetingUsersParticipants.filter(user => user.type === 1);
                    memberList = sortByProperty(memberList, "indexNo")
                    let participantList = meetingUsersParticipants.filter(user => user.type === 2);
                    participantList = sortByProperty(participantList, "indexNo")
                    setMembers(memberList);
                    setParticipants(participantList);
                }
            } catch (error) {
                console.error("Error fetching meeting participants:", error);
            }
        };

        if (meeting && meeting.id) {
            fetchParticipants();
        }
    }, [meeting, userList]);

    const { smallFontSize, avatarSize, fabStyle } = useTemplateFontSettings()
    return (
        <JumboCardQuick
            title={
                <Typography sx={{ fontSize: smallFontSize, lineHeight: 1 }}>
                    Toplantının Üye ve Katılımcıları
                </Typography>
            }
            headerSx={{ borderBottom: 1, borderBottomColor: "divider" }}
            wrapperSx={{ p: 0 }}
        >
            {/* <JumboScrollbar
                autoHeight
                autoHeightMin={300}
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            > */}
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 1, fontSize: smallFontSize, lineHeight: 1 }}>
                            <Chip label={`${members.length} Üye`} color="primary" size="small" />
                        </Typography>
                        {members.length === 0 ? (
                            <Typography variant="body2" sx={{ fontSize: smallFontSize, lineHeight: 1 }}>
                                Üye bulunamadı.
                            </Typography>
                        ) : (
                            members.map((member) => (
                                <Box
                                    key={member.userId}
                                    sx={{

                                        borderBottom: "1px solid #f0f0f0",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Avatar
                                        alt={member.user ? member.user.name : ""}
                                        src={
                                            member.user && member.user.profileImageUrl
                                                ? `${config.userAuthApiUrl}${member.user.profileImageUrl}`
                                                : undefined
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                                config.userAuthApiUrl + config.defaultProfileImageUrl;
                                        }}
                                        sx={{ ...fabStyle }}
                                    />
                                    <Typography variant="body2" sx={{ fontSize: smallFontSize, lineHeight: 1 }}>
                                        {getUserFullName(member.user)} ({member.inst})

                                        {member.memberRole === "Başkan" || member.memberRole === "Başkan Yrd" ? (
                                            <span style={{ fontStyle: "italic", fontSize: smallFontSize }}>{" "}  ({member.memberRole})</span>
                                        ) : null}

                                        {member.acting === "Vekaleten" ? (
                                            <span style={{ fontStyle: "italic", fontSize: smallFontSize }}>{" "}  (V.)</span>
                                        ) : null}

                                        {member.attendanceStatus === 0 || member.attendanceStatus === '0' ? (
                                            <span style={{ fontStyle: "italic", fontSize: smallFontSize }}>{" "}  ({"Katılmadı"})</span>
                                        ) : null}
                                    </Typography>
                                </Box>
                            ))
                        )}
                    </Box>

                    {/* Katılımcılar Sütunu */}
                    <Box sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 1, fontSize: smallFontSize, lineHeight: 1 }}>
                            <Chip label={`${participants.length} Katılımcı`} color="primary" size="small" />
                        </Typography>
                        {participants.length === 0 ? (
                            <Typography variant="body2" sx={{ fontSize: smallFontSize, lineHeight: 1 }}>
                                Katılımcı bulunamadı.
                            </Typography>
                        ) : (
                            participants.map((participant) => (
                                <Box
                                    key={participant.userId}
                                    sx={{

                                        borderBottom: "1px solid #f0f0f0",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Avatar
                                        alt={participant.user ? participant.user.name : ""}
                                        src={
                                            participant.user && participant.user.profileImageUrl
                                                ? `${config.userAuthApiUrl}${participant.user.profileImageUrl}`
                                                : undefined
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                                config.userAuthApiUrl + config.defaultProfileImageUrl;
                                        }}
                                        sx={{ ...fabStyle }}
                                    />
                                    <Typography variant="body2" sx={{ fontSize: smallFontSize, lineHeight: 1 }}>
                                        {getUserFullName(participant.user)}
                                    </Typography>
                                </Box>
                            ))
                        )}
                    </Box>
                </Box>
            </Box>
            {/* </JumboScrollbar> */}
        </JumboCardQuick>
    );
}

export default PreviewMeetingUsersCard;